import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { baseManagementGuard } from './core/guards/base-management.guard';
import { landingGuard } from './core/guards/landing.guard';
import { privilegeGuard } from './core/guards/privilege.guard';
import { guestGuard } from './core/guards/guest.guard';
import { APP_PATHS, BASE_MANAGEMENT_PRIVILEGES } from './core/constants/app-config.constants';
import {
  APPROVALS_VIEW_PRIVILEGES,
  ATTENDANCE_LOG_VIEW_PRIVILEGES,
  CREW_PRIVILEGES,
  FIXED_WING_PRIVILEGES,
  MASTER_SCHEDULE_PRIVILEGES,
  ROTOR_WING_PRIVILEGES,
} from './core/constants/privileges.constants';

export const routes: Routes = [
  {
    path: APP_PATHS.OFFLINE,
    loadComponent: () =>
      import('./features/offline/offline.component').then((m) => m.OfflineComponent),
  },
  {
    path: APP_PATHS.LOGIN,
    canActivate: [guestGuard],
    loadComponent: () => import('./features/auth/login/login').then((m) => m.LoginComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./core/layouts/app-layout/app-layout.component').then((m) => m.AppLayoutComponent),
    children: [
      {
        path: APP_PATHS.HOME,
        loadComponent: () =>
          import('./features/home/pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: APP_PATHS.MASTER_SCHEDULE,
        canActivate: [privilegeGuard],
        data: { privileges: MASTER_SCHEDULE_PRIVILEGES },
        loadComponent: () =>
          import('./features/master-schedule/pages/master-schedule-builder/master-schedule-builder.component').then(
            (m) => m.MasterScheduleBuilderComponent
          ),
      },
      {
        path: APP_PATHS.DAILY_LINE_SCHEDULING,
        canActivate: [privilegeGuard],
        data: { privileges: ROTOR_WING_PRIVILEGES },
        loadComponent: () =>
          import('./features/daily-line-schedule/pages/daily-line-scheduling/daily-line-scheduling.component').then(
            (m) => m.DailyLineSchedulingComponent
          ),
      },
      {
        path: APP_PATHS.FIXED_WING,
        canActivate: [privilegeGuard],
        data: { privileges: FIXED_WING_PRIVILEGES },
        loadComponent: () =>
          import('./features/fixed-wing/pages/fixed-wing-scheduling/fixed-wing-scheduling.component').then(
            (m) => m.FixedWingSchedulingComponent
          ),
      },
      {
        path: APP_PATHS.BASE_MANAGEMENT,
        canActivate: [privilegeGuard, baseManagementGuard],
        data: { privileges: BASE_MANAGEMENT_PRIVILEGES },
        loadComponent: () =>
          import('./features/base-management/pages/base-management/base-management.component').then(
            (m) => m.BaseManagementComponent
          ),
      },
      {
        path: APP_PATHS.BASE_DETAILS,
        canActivate: [privilegeGuard, baseManagementGuard],
        data: { privileges: BASE_MANAGEMENT_PRIVILEGES },
        loadComponent: () =>
          import('./features/base-management/pages/base-details/base-details.component').then(
            (m) => m.BaseDetailsComponent
          ),
      },
      {
        path: APP_PATHS.EDIT_CREW,
        canActivate: [privilegeGuard],
        data: { privileges: CREW_PRIVILEGES },
        loadComponent: () =>
          import('./features/edit-crew/pages/edit-crew-details/edit-crew-details.component').then(
            (m) => m.EditCrewDetailsComponent
          ),
      },
      {
        path: APP_PATHS.APPROVALS,
        canActivate: [privilegeGuard],
        data: { privileges: APPROVALS_VIEW_PRIVILEGES },
        loadComponent: () =>
          import('./features/approvals/pages/approvals/approvals.component').then(
            (m) => m.ApprovalsComponent
          ),
      },
      {
        path: APP_PATHS.ATTENDANCE_LOG,
        canActivate: [privilegeGuard],
        data: { privileges: ATTENDANCE_LOG_VIEW_PRIVILEGES },
        loadComponent: () =>
          import('./features/attendance-log/pages/attendance-log/attendance-log.component').then(
            (m) => m.AttendanceLogComponent
          ),
      },
      {
        path: APP_PATHS.ATTENDANCE_LOG_DETAIL,
        canActivate: [privilegeGuard],
        data: { privileges: ATTENDANCE_LOG_VIEW_PRIVILEGES },
        loadComponent: () =>
          import('./features/attendance-log/pages/attendance-log-detail/attendance-log-detail.component').then(
            (m) => m.AttendanceLogDetailComponent
          ),
      },
      // The page used to live at /audit-log; keep old bookmarks and links working.
      { path: 'audit-log', redirectTo: APP_PATHS.ATTENDANCE_LOG, pathMatch: 'full' },
      { path: 'audit-log/:crewId', redirectTo: APP_PATHS.ATTENDANCE_LOG_DETAIL, pathMatch: 'full' },
      {
        path: APP_PATHS.FORBIDDEN,
        loadComponent: () =>
          import('./features/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
      },
      {
        path: '',
        pathMatch: 'full',
        canActivate: [landingGuard],
        loadComponent: () =>
          import('./features/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
      },
      {
        path: '**',
        canActivate: [landingGuard],
        loadComponent: () =>
          import('./features/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
      },
    ],
  },
  {
    path: '**',
    canActivate: [authGuard, landingGuard],
    loadComponent: () =>
      import('./features/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
  },
];
